import { Heading } from '@slal/ui/typography';
import { ComponentPropsWithoutRef } from 'react';
import { CardBody, CardWrapper } from './styles';

interface CardProps extends ComponentPropsWithoutRef<'div'> {
    heading?: string;
    disabled?: boolean;
}

export const Card = ({ heading, disabled, children, ...otherProps }: CardProps) => (
    <CardWrapper disabled={disabled} {...otherProps}>
        {heading && <Heading level={3}>{heading}</Heading>}
        {!disabled && <CardBody>{children}</CardBody>}
    </CardWrapper>
);
